import * as React from 'react';
import { Field, InjectedFormProps } from 'redux-form';
import Button from '@material-ui/core/Button/Button';
import ViewEditField from './ViewEditField/ViewEditField';
import Grid from '@material-ui/core/Grid/Grid';
import * as styles from './ViewEditForm.css';

export type ViewEditFormProps = EnteredViewEditFormProps &
  InjectedFormProps<{}, EnteredViewEditFormProps>;

interface EnteredViewEditFormProps {
  fieldData: Array<{
    name: string;
    type: FieldType;
    fieldFormat?: FieldFormat;
    label: string;
    options?: Array<{ name: string; value: string }>;
    validate: Array<(value: string) => string | undefined>;
  }>;
  initialEditing: boolean;
}

interface ViewEditFormState {
  settingState: boolean;
}

class ViewEditForm extends React.Component<ViewEditFormProps, ViewEditFormState> {
  constructor(props: ViewEditFormProps) {
    super(props);
    this.state = { settingState: props.initialEditing };
  }
  componentDidMount() {
    if (this.props.initialEditing) {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }

  public render() {
    const { handleSubmit, submitting, fieldData } = this.props;
    return (
      <form
        onSubmit={event => {
          this.setState({ settingState: false });
          return handleSubmit(event);
        }}>
        <Grid item xs={12} container direction="column" justify="space-between">
          <Grid item>
            {fieldData.map(data => (
              <Field
                key={data.label}
                {...data}
                component={ViewEditField}
                disabled={!this.state.settingState}
              />
            ))}
          </Grid>
          <Grid item container justify="center" style={{ marginBottom: '20px' }}>
            {this.state.settingState ? (
              <span>
                <Button
                  className={styles.cancel}
                  onClick={() => this.setState({ settingState: false })}>
                  Cancel
                </Button>
                <Button
                  size="large"
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={submitting}>
                  Submit
                </Button>
              </span>
            ) : (
              <Button
                size="large"
                variant="contained"
                color="primary"
                onClick={() => this.setState({ settingState: true })}
                type="button">
                Edit
              </Button>
            )}
          </Grid>
        </Grid>
      </form>
    );
  }
}
export default ViewEditForm;
